import { IonRow } from '@ionic/react';
import React from 'react';
import { useIntl } from 'react-intl';
import { DqText } from '../../../dq-text';
import { JobMessages } from 'src/intl/JobMessages';
import './InformationModals.scss';
import { AppModal } from '../../../reusable-components/app-modal/AppModal';

interface InstructionsModalProps {
  /**
   * Whether the modal is open.
   */
  isOpen: boolean;
  /**
   * Triggers the request to close the modal.
   */
  onClose: () => void;
  /** Title text */
  title: string;
  /** Body text. */
  bodyText: string;
  /** Image content from import statement */
  image: string;
}

export const InstructionsModal: React.FC<InstructionsModalProps> = ({ onClose, isOpen, title, bodyText, image }) => {
  const { formatMessage } = useIntl();

  return (
    <AppModal
      isOpen={isOpen}
      title={title}
      onClose={onClose}
      primaryButton={{
        label: formatMessage(JobMessages.gotItButton),
        onClick: onClose,
      }}
    >
      <DqText variant="body">{bodyText}</DqText>
      <IonRow className="ion-justify-content-center ion-padding">
        <img src={image} alt="depth cleaned diagram" />
      </IonRow>
    </AppModal>
  );
};

export default InstructionsModal;
